
import { sharedStyles } from 'components/TransactionRegister/sharedStyles';

export const styles = (theme) => ({
  ...sharedStyles(theme),
  helpIcon: {
    display: 'flex',
    cursor: 'pointer',
    color: theme.palette.greyScale[2],
  },
  dialogRoot: {
    zIndex: '1501 !important',
  },
  headerContainer: {
    height: 67,
    padding: 8,
    background: '#cbd2d8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerCheckbox: {
    border: 'solid',
    borderWidth: 1,
    borderColor: '#a8a8a8',
  },
  headerLabel: {
    display: 'flex',
    marginLeft: 7,
    fontSize: '14px',
    fontWeight: 500,
  },
});
